export default {
  methods: {
    enablePanel(panel_name) {
      let panel_list = this.$store.getters.getPanelSetting;
      let path_name = this.$route.path;
      // if(this.isAdmin) path_name = this.$route.path.replace('/office/admin/', '');
      // else path_name = this.$route.path.replace('/office/partner/', '');
      if(path_name.indexOf('delivery/product/create')>-1) path_name = path_name.replace('delivery/', '');
      let page = find(panel_list, 'path', this.changePath(path_name));

      // 페이지 없을 경우 예외처리
      if(!page) return true;

      let panel = find(page.panel, 'panel', panel_name);
      if (panel) return panel.enable;
      else return true;
    },
    savePanel(path, panel_name) {
      let panel = find(this.panelSetting, 'path', path);
      this.$axios.patch(`admin/panel/${panel.id}/setting`, {
        panel: this.page.panel
      })
    },
    // 인풋 숫자 입력시 max_length 조건에 맞춰서 return
    setNumber(e, depth1, depth2, max_length){
      if(e.target.value.length > max_length) this[depth1][depth2] = parseInt(e.target.value.substr(0,max_length));
      else this[depth1][depth2] = parseInt(e.target.value);
    }
  }
}
